import React, { Component } from 'react';
import LoginFooterNavigation from './partials/LoginFooterNavigation';
import logo from '../img/energyaid.png';

class Help extends Component {
    componentWillMount() {
        document.getElementById('body').className='dark';
    }

    render() {
        return (
            <div>
                <div className="masthead">
                    <img src={ logo } alt="EnergyAid" />  
                </div>

                <div className="container">
                    <div className="col-12">
                        <h1 className="text-center">Hjälp</h1>
                        <p><strong>Deltagare:</strong> Har du glömt bort din inloggningskod? Kontakta din gruppadministratör så får du hjälp med det.</p>

                        <p><strong>Admin:</strong> Har du problem med att logga in i appen? Kontakta EnergyAid på <a href="mailto:info@energyaid.se">info@energyaid.se</a>. Har du glömt bort ditt lösenord klickar du på Glömt lösenord och fyller i din email så får du instruktioner skickat till dig hur du skapar ett nytt.</p>

                        <LoginFooterNavigation />
                    </div>
                </div>
            </div>
        )
    }
}

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help.js